











import { Component, Vue } from 'vue-property-decorator'
import request, { Response } from '@/helpers/requests'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import TechTaskCard from '@/components/ui/TechTaskCard.vue'
import TWMTemplates from '@/pages/TWMCustomTemplates/TWMTemplates.vue'
import { TWMTemplatesInterface } from '@/pages/TWMCustomTemplates/types/twm-templates'


interface LoadRequestPayload {
    pulsemAccountId: number;
}


interface RequestPayload {
    pulsemAccountId: number;
    twmTemplates: TWMTemplatesInterface;
}


interface ResponsePayload extends Response {
    data: TWMTemplatesInterface;
}


@Component({
    components: {
        AccountIdInput,
        TechTaskCard,
        TWMTemplates
    }
})
export default class TWMCustomTemplates extends Vue {
    locationValid = false
    pulsemAccountId: number|null = null
    twmTemplates: TWMTemplatesInterface|null = null

    get requestPayload(): RequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId as number,
            twmTemplates: this.twmTemplates as TWMTemplatesInterface
        }
    }

    get loadRequestPayload(): LoadRequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId as number
        }
    }

    async load(): Promise<ResponsePayload> {
        return await request.post('/support/twm-custom-templates-load', this.loadRequestPayload) as ResponsePayload
    }

    async onLocationChange(locationValid: boolean) {
        if (locationValid) {
            const response = await this.load()
            this.twmTemplates = response.data
        } else {
            this.twmTemplates = null
        }
        this.locationValid = locationValid
    }

    onSuccess(status: boolean) {
        if (status) {
            this.locationValid = false
            this.pulsemAccountId = null
            this.twmTemplates = null
        }
    }
}
